import React from "react";
import { Grid, Typography } from "@mui/material";
import { VehicleNumberField, VehicleDateField } from "../VehicleFormFields";

const OdometerTab: React.FC = () => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Track mileage and odometer readings for maintenance scheduling.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <VehicleNumberField 
            name="lastOdometerReading" 
            label="Last Odometer Reading" 
            tooltip="Most recent odometer reading in miles"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleDateField 
            name="lastOdometerDate" 
            label="Last Odometer Date" 
            tooltip="Date when the last odometer reading was taken"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleNumberField 
            name="estimatedOdometer" 
            label="Estimated Odometer" 
            tooltip="Estimated current odometer reading"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OdometerTab;
